module.exports = __webpack_public_path__ + "img/rp_05.58e5630e.jpg";